import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  footer: {
    position: "fixed",
    boxSizing: "border-box",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    maxHeight: "34px",
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.mainButton.darkBlue,
    zIndex: 1250,
    [theme.breakpoints.down(1125)]: {
      maxHeight: "52px",
    },
    [theme.breakpoints.down(721)]: {
      maxHeight: "50px",
    },
    // minWidth: 1440
  },

  footerContainer: {
    display: "grid",
    gridTemplateColumns: "auto auto auto",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 30px",
    width: "100%",
    gap: 0,
    [theme.breakpoints.down(1125)]: {
      gap: "8px",
      justifyContent: "start",
      padding: "0 20px",
      gridTemplate: "'a b' 'c c'",
    },
    [theme.breakpoints.down(721)]: {
      padding: "0 10px",
      gridTemplate: "none",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "6px",
    },
    "& div:last-child p": {
      [theme.breakpoints.down(1125)]: {
        fontSize: "10px",
      },
      [theme.breakpoints.down(721)]: {
        fontSize: 8,
      },
    },
  },

  leftPart: {
    [theme.breakpoints.down(1125)]: {
      gridArea: "a",
    },
    [theme.breakpoints.down(721)]: {
      gridArea: "none",
    },
  },

  centerPart: {
    display: "flex",
    gap: 24,
    alignItems: "center",
    height: "14px",
    [theme.breakpoints.down(1125)]: {
      gridArea: "b",
    },
    [theme.breakpoints.down(721)]: {
      gridArea: "none",
      height: "8px",
      gap: 18,
    },
  },

  rightPart: {
    [theme.breakpoints.down(1125)]: {
      gridArea: "c",
    },
    [theme.breakpoints.down(721)]: {
      gridArea: "none",
    },
  },
  footerTextBlock: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: 5,
  },
  footerKey: {
    margin: 0,
    padding: 0,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "100%",
    textTransform: "none",
    color: theme.palette.mainButton.blue,
    [theme.breakpoints.down(721)]: {
      fontSize: 8,
    },
  },
  footerText: {
    margin: 0,
    padding: 0,
    color: theme.palette.mainButton.contrastText,
    /*fontFamily: "Roboto",*/
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "100%",
    [theme.breakpoints.down(721)]: {
      fontSize: 8,
    },
  },
}));

export default useStyles;
